function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Table } from 'antd';
import Common from "../components/includes/Common";
import Moment from 'react-moment';
import { CheckCircleFill, Eyedropper, EyeFill, HeartPulseFill, Person } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var QueueDisplay = function QueueDisplay() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    laboQueueData = _useState2[0],
    setLaboQueueData = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    medQueueData = _useState4[0],
    setMedQueueData = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    visioQueueData = _useState6[0],
    setVisioQueueData = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    validationQueueData = _useState8[0],
    setValidationQueueData = _useState8[1];
  var _useState9 = useState(true),
    _useState10 = _slicedToArray(_useState9, 2),
    isDataLoading = _useState10[0],
    setIsDataLoading = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    nextLaboCandidate = _useState12[0],
    setNextLaboCandidate = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    nextMedCandidate = _useState14[0],
    setNextMedCandidate = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    nextVisioCandidate = _useState16[0],
    setNextVisioCandidate = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    nextValidationCandidate = _useState18[0],
    setNextValidationCandidate = _useState18[1];
  var cols = [{
    title: "#",
    dataIndex: "num",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "num"
  }, {
    title: "Date",
    dataIndex: "date",
    render: function render(date) {
      return /*#__PURE__*/_jsx(Moment, {
        format: "DD/MM/YYYY HH:mm",
        date: date
      });
    },
    key: "date"
  }, {
    title: "Candidat",
    dataIndex: "candidate",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "candidate"
  }];
  useEffect(function () {
    setIsDataLoading(true);
    axios.all([axios.get(Common.baseApiUrl + 'getcurrentdayqueue/' + Common.currentUser.id), axios.get(Common.baseApiUrl + 'getcurrentdaysampled/' + Common.currentUser.id), axios.get(Common.baseApiUrl + 'getvisioqueue/' + Common.currentUser.id), axios.get(Common.baseApiUrl + 'getvalidationqueue/' + Common.currentUser.id)]).then(function (response) {
      if (response[0].data.status == 200) {
        response[0].data.customers.forEach(function (e) {
          setLaboQueueData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              num: e.rank,
              date: e.created_at,
              candidate: e.firstname + ' ' + e.lastname
            }]);
          });
        });
      }
      if (response[1].data.status == 200) {
        response[1].data.customers.forEach(function (e) {
          setMedQueueData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              num: e.rank,
              date: e.created_at,
              candidate: e.firstname + ' ' + e.lastname
            }]);
          });
        });
      }
      if (response[2].data.status == 200) {
        response[2].data.customers.forEach(function (e) {
          setVisioQueueData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              num: e.rank,
              date: e.created_at,
              candidate: e.firstname + ' ' + e.lastname
            }]);
          });
        });
      }
      if (response[3].data.status == 200) {
        response[3].data.customers.forEach(function (e) {
          setValidationQueueData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              num: e.rank,
              date: e.created_at,
              candidate: e.firstname + ' ' + e.lastname
            }]);
          });
        });
      }
    })["catch"](function (error) {})["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "square",
            children: [/*#__PURE__*/_jsx("div", {
              style: {
                padding: '7px',
                color: '#EEE',
                background: '#854F4B'
              },
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(Eyedropper, {
                  size: 26
                }), " ATTENTE DE PRELEVEMENT"]
              })
            }), /*#__PURE__*/_jsx(Table, {
              size: "small",
              columns: cols,
              bordered: true,
              sticky: true,
              loading: isDataLoading,
              dataSource: laboQueueData.slice(0, 4),
              pagination: false
            }), /*#__PURE__*/_jsx("br", {}), laboQueueData.length > 0 && isDataLoading == false && /*#__PURE__*/_jsx(Container, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  children: /*#__PURE__*/_jsxs("h1", {
                    style: {
                      color: '#854F4B',
                      fontWeight: 'bold',
                      textAlign: 'center',
                      fontSize: '60px'
                    },
                    children: [/*#__PURE__*/_jsx(Person, {
                      size: 60
                    }), '#' + laboQueueData.slice(0, 1)[0].num]
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6
                })]
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "square",
            children: [/*#__PURE__*/_jsx("div", {
              style: {
                padding: '7px',
                color: '#EEE',
                background: '#0575AA'
              },
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(HeartPulseFill, {
                  size: 26
                }), " ATTENTE DE CONSULTATIONN"]
              })
            }), /*#__PURE__*/_jsx(Table, {
              size: "small",
              columns: cols,
              bordered: true,
              sticky: true,
              loading: isDataLoading,
              dataSource: medQueueData.slice(0, 4),
              pagination: false
            }), /*#__PURE__*/_jsx("br", {}), medQueueData.length > 0 && isDataLoading == false && /*#__PURE__*/_jsx(Container, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  children: /*#__PURE__*/_jsxs("h1", {
                    style: {
                      color: '#0575AA',
                      fontWeight: 'bold',
                      textAlign: 'center',
                      fontSize: '60px'
                    },
                    children: [/*#__PURE__*/_jsx(Person, {
                      size: 60
                    }), '#' + medQueueData.slice(0, 1)[0].num]
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6
                })]
              })
            })]
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "square",
            children: [/*#__PURE__*/_jsx("div", {
              style: {
                padding: '7px',
                color: '#EEE',
                background: '#03405D'
              },
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(EyeFill, {
                  size: 26
                }), " ATTENTE DE VISIO TESTE"]
              })
            }), /*#__PURE__*/_jsx(Table, {
              size: "small",
              columns: cols,
              bordered: true,
              sticky: true,
              loading: isDataLoading,
              dataSource: visioQueueData.slice(0, 4),
              pagination: false
            }), /*#__PURE__*/_jsx("br", {}), visioQueueData.length > 0 && isDataLoading == false && /*#__PURE__*/_jsx(Container, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  children: /*#__PURE__*/_jsxs("h1", {
                    style: {
                      color: '#03405D',
                      fontWeight: 'bold',
                      textAlign: 'center',
                      fontSize: '60px'
                    },
                    children: [/*#__PURE__*/_jsx(Person, {
                      size: 60
                    }), '#' + visioQueueData.slice(0, 1)[0].num]
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6
                })]
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "square",
            children: [/*#__PURE__*/_jsx("div", {
              style: {
                padding: '7px',
                color: '#EEE',
                background: '#584B85'
              },
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(CheckCircleFill, {
                  size: 26
                }), " ATTENTE DE VALIDATION"]
              })
            }), /*#__PURE__*/_jsx(Table, {
              size: "small",
              columns: cols,
              bordered: true,
              sticky: true,
              loading: isDataLoading,
              dataSource: validationQueueData.slice(0, 4),
              pagination: false
            }), /*#__PURE__*/_jsx("br", {}), validationQueueData.length > 0 && isDataLoading == false && /*#__PURE__*/_jsx(Container, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  children: /*#__PURE__*/_jsxs("h1", {
                    style: {
                      color: '#584B85',
                      fontWeight: 'bold',
                      textAlign: 'center',
                      fontSize: '60px'
                    },
                    children: [/*#__PURE__*/_jsx(Person, {
                      size: 60
                    }), '#' + validationQueueData.slice(0, 1)[0].num]
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6
                })]
              })
            })]
          })
        })]
      })]
    }), /*#__PURE__*/_jsx("br", {})]
  });
};
export default QueueDisplay;